export default __webpack_public_path__ + "0807cf8bddb9fe2f565b58058a5d2cfb.png";